import React from "react";
import styles from "./ProductDetailDialog.module.css";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import CloseIcon from "@material-ui/icons/Close";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";

import { CardDetailContainer } from "components/CardDetail";
import PropTypes from "prop-types";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ProductDetailDialog = (props) => {
  const { id, open, onClose, onAddToShoppingCart } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      className={styles.dia_container}
      fullWidth={true}
      maxWidth={"md"}
      TransitionComponent={Transition}
    >
      <DialogContent>
        <CardDetailContainer id={id} />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="secondary"
          startIcon={<CloseIcon />}
        >
          Cancel
        </Button>
        <Button
          onClick={onAddToShoppingCart}
          color="primary"
          startIcon={<AddShoppingCartIcon />}
        >
          Add To Cart
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ProductDetailDialog.propTypes = {
  id: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onAddToShoppingCart: PropTypes.func,
};

ProductDetailDialog.defaultProps = {
  onClose: () => {},
};

export default ProductDetailDialog;
